import { useEffect, useState } from 'react'

import {
  getDataFromSessionStorage,
  removeDataFromSessionStorage,
  setDataToSessionStorage,
} from 'src/utils/sessionStorage'

export default function useSaveRegistrationData<T extends Record<string, unknown>, F extends Record<string, unknown>>(
  key: string,
  defaultValues: T,
  defaultTouched: F,
): [initialValues: T, initialTouched: F, saveInitialValues: (values: T) => void, removeSavedValues: () => void] {
  const [initialValues, setInitialValues] = useState(defaultValues)
  const [initialTouched, setInitialTouched] = useState(defaultTouched)

  const saveInitialValues = (values: T) => {
    setDataToSessionStorage(key, values)
  }

  const removeSavedValues = () => {
    removeDataFromSessionStorage(key)
  }

  useEffect(() => {
    const savedValues = getDataFromSessionStorage<T>(key)

    if (savedValues && typeof savedValues === 'object') {
      setInitialValues(savedValues)
      setInitialTouched(
        Object.keys(savedValues).reduce((acc, keyValue) => {
          return { ...acc, [keyValue]: !!savedValues[keyValue] }
        }, initialTouched),
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return [initialValues, initialTouched, saveInitialValues, removeSavedValues]
}
